import React, { useEffect, useState } from 'react';
import { Alert, AlertIcon, AlertDescription, Box, Link as ChakraLink } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import settingsService from '../services/settingsService';

/**
 * Persistent banner shown on every page while this hotel's communications
 * hold is on (Settings → Communications). Reuses /v1/settings — already
 * loaded for Hotel Settings and open to any authenticated staff member —
 * so showing the banner costs no extra endpoint/permission.
 */
const CommunicationsHoldBanner = () => {
  const { t } = useTranslation();
  const [onHold, setOnHold] = useState(false);

  useEffect(() => {
    let cancelled = false;
    settingsService.getSettings()
      .then((res) => {
        if (!cancelled) setOnHold(Boolean(res?.communicationsHold));
      })
      .catch(() => { /* banner just stays hidden if settings can't load */ });
    return () => { cancelled = true; };
  }, []);

  if (!onHold) return null;

  return (
    <Box position="sticky" top={0} zIndex={1500} width="100%">
      <Alert status="warning" bg="orange.400" color="black" borderRadius={0} px={4} py={2} justifyContent="center">
        <AlertIcon color="black" />
        <AlertDescription fontSize="sm" fontWeight="medium">
          {t('communicationsHold.banner.message')}{' '}
          <ChakraLink as={RouterLink} to="/settings" fontWeight="bold" textDecoration="underline">
            {t('communicationsHold.banner.manageLink')}
          </ChakraLink>
        </AlertDescription>
      </Alert>
    </Box>
  );
};

export default CommunicationsHoldBanner;
